export const STREETKIT_DETAIL_BUCKET_STRATEGY_PREFIX = "streetkit-id-fnv1a-prefix-" as const;
export const STREETKIT_DETAIL_BUCKET_PREFIX_LENGTH = 3;
export const STREETKIT_LEGACY_DETAIL_BUCKET_PREFIX_LENGTH = 4;
export const STREETKIT_DETAIL_BUCKET_STRATEGY =
  `${STREETKIT_DETAIL_BUCKET_STRATEGY_PREFIX}${STREETKIT_DETAIL_BUCKET_PREFIX_LENGTH}` as const;
export const STREETKIT_LEGACY_DETAIL_BUCKET_STRATEGY =
  `${STREETKIT_DETAIL_BUCKET_STRATEGY_PREFIX}${STREETKIT_LEGACY_DETAIL_BUCKET_PREFIX_LENGTH}` as const;

export function detailBucketStrategyForPrefixLength(prefixLength: number): string {
  return `${STREETKIT_DETAIL_BUCKET_STRATEGY_PREFIX}${normaliseDetailBucketPrefixLength(prefixLength)}`;
}

export function detailBucketPrefixLengthFromStrategy(
  strategy: string | null | undefined,
  fallback = STREETKIT_DETAIL_BUCKET_PREFIX_LENGTH
): number {
  const match = /^streetkit-id-fnv1a-prefix-(\d+)$/u.exec(strategy ?? "");
  if (match?.[1] === undefined) {
    return normaliseDetailBucketPrefixLength(fallback);
  }

  return normaliseDetailBucketPrefixLength(Number(match[1]));
}

export function detailBucketForId(
  id: string,
  prefixLength = STREETKIT_DETAIL_BUCKET_PREFIX_LENGTH
): string {
  let hash = 0x811c9dc5;

  for (let index = 0; index < id.length; index += 1) {
    hash ^= id.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }

  return hash.toString(16).padStart(8, "0").slice(0, normaliseDetailBucketPrefixLength(prefixLength));
}

export function normaliseDetailBucketPrefixLength(prefixLength: number): number {
  if (!Number.isInteger(prefixLength) || prefixLength < 1 || prefixLength > 8) {
    throw new Error("StreetKit detail bucket prefix length must be an integer from 1 to 8.");
  }

  return prefixLength;
}
